import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Select from 'react-select'
import { fetchOrders } from "../../actions/orderActions"
import { setDate } from "../../actions/calendarActions"
import { fetchCalendarTodos } from "../../actions/todoActions"
import BigCalendar from 'react-big-calendar'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'
import { sortOpts } from '../../utils/utils';

require('react-big-calendar/lib/css/react-big-calendar.css');

BigCalendar.setLocalizer(
  BigCalendar.momentLocalizer(moment)
);

function Event({ event }) {
  if (event.comp) {
    return (
      <span>
        <strong>{event.comp || ""}</strong>{" "}
        {event.title}
      </span>
    );
  }
  return (
    <span>
      <span
        className="glyphicon glyphicon-check"
        style={{color: event.iconColor}}
      />{" "}
      {event.title}
    </span>
  );
}

function EventWrapper({ event, children }) {
  return(
    {
      ...children,
      props:{
        ...children.props,
        style:{
          backgroundColor: event.color || 'transparent',
          color: 'black'
        }
      }
    }
  );
}

class CalendarPage extends React.Component {

  state = {
    user_id: 0
  }

  componentWillMount(){
    this.props.fetchOrders();
    this.props.fetchCalendarTodos();
  }

  showOrder = id => {
    this.context.router.push('/order/edit?id='+id);
  }

  setDate = e => {
    this.props.setDate(e);
  }

  updateSelect = e => {
    this.setState({
      user_id: e ? e.value : 0
    });
  }

  render() {
    if(isEmpty(this.props.places)
      || isEmpty(this.props.comps)
      || isEmpty(this.props.orders)
      || isEmpty(this.props.sttss)
    ){
      return(<div>Не загружены данные</div>);
    }
    const { orders, comps, places, sttss, calDate, filter, todos, users } = this.props;
    const { user_id } = this.state;
    const date = new Date();
    const today = date.toISOString().slice(0, 10);
    const messages = {
      allDay: 'Весь день',
      previous: 'Назад',
      next: 'Вперед',
      today: 'Сегодня',
      month: 'Месяц',
      week: 'Неделя',
      day: 'День',
      agenda: 'Повестка дня'
    };
    const fltrOrders = orders.filter(el =>{
      for (var i = 0; i < filter.length; i++){
        if(el.order_stts_id === filter[i]){
          return true;
        }
      }
      return false;
    });
    const fltrTodos = todos.filter(el =>{
      if(!user_id || el.todo_user_id === user_id){
        return true;
      }
      return false;
    });
    let events = fltrOrders.map(el => {
      return {
        title:el.order_desc+" "+places[el.order_place_id].place_desc,
        comp:comps[el.order_comp_id].comp_desc,
        start:moment(el.order_edate),
        end:moment(el.order_edate),
        allDay: true,
        orderId: el.order_id,
        color:sttss[el.order_stts_id].stts_color_id
      };
    });
    events = events.concat(fltrTodos.map(el => {
      return {
        title: el.todo_desc+" - "+el.order_desc,
        start: moment(el.todo_dline),
        end: moment(el.todo_dline),
        allDay: true,
        orderId: el.order_id,
        iconColor: today > el.todo_dline ? 'crimson' : 'green'
      };
    }));
    var usersOpt = [];
    for (let key in users){
      if(users.hasOwnProperty(key) && users[key].user_active){
        usersOpt.push({
          value: users[key].user_id,
          label: users[key].user_fname + " " + users[key].user_lname
        });
      }
    }
    usersOpt.sort(sortOpts);
    return (
      <div className="full-height">
        <div style={{marginBottom: '10px'}}>
          <div className="input-group col-sm-3" style={{zIndex: 99}}>
            <Select
              options={usersOpt}
              value={user_id}
              onChange={this.updateSelect}
              placeholder="Фильтр задач"
            />
          </div>
        </div>
        <BigCalendar
          popup
          date={calDate}
          className="full-height"
          events={events}
          messages={messages}
          onSelectEvent={event => this.showOrder(event.orderId)}
          components={{event: Event, eventWrapper: EventWrapper}}
          onNavigate={this.setDate}
        />
      </div>
    );
  }
}

CalendarPage.contextTypes = {
  router: PropTypes.object.isRequired
}

function mapOrdersToProps(store) {
  return {
    orders: store.orders.data,
    filter: store.orders.filter,
    places: store.places.data,
    comps: store.comps.data,
    users: store.empls,
    sttss: store.sttss.data,
    calDate: store.calendar.date,
    todos: store.calendar.todos
  }
}

export default connect(mapOrdersToProps, { fetchOrders, setDate, fetchCalendarTodos })(CalendarPage);



// WEBPACK FOOTER //
// ./src/components/calendar/CalendarPage.js